__turbopack_context__.v({
  "avatarContainer": "OrganizerData-module-scss-module__KEVIQG__avatarContainer",
  "contentContainer": "OrganizerData-module-scss-module__KEVIQG__contentContainer",
  "organizerName": "OrganizerData-module-scss-module__KEVIQG__organizerName",
  "wrapper": "OrganizerData-module-scss-module__KEVIQG__wrapper",
});
